"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeLogService = void 0;
//ANGULAR BITS
const core_1 = require("@angular/core");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
//INTERNAL LIBRARY BITS
const notification_service_1 = require("./notification.service");
const version_pipe_1 = require("./version.pipe");
var DiffType;
(function (DiffType) {
    DiffType[DiffType["Addition"] = 1] = "Addition";
    DiffType[DiffType["Modification"] = 2] = "Modification";
    DiffType[DiffType["Other"] = 3] = "Other";
    DiffType[DiffType["ArrayMove"] = 3] = "ArrayMove";
    DiffType[DiffType["TextDiff"] = 2] = "TextDiff";
})(DiffType || (DiffType = {}));
function parseTextDiff(value) {
    return value.split('\n@@ ').map(line => {
        const location = /^(?:@@ )?[-+]?(\d+),(\d+)/.exec(line).slice(1);
        return {
            location: location.join(','),
            pieces: line.split('\n')
                .slice(1)
                .filter(i => i.length)
                .map(piece => {
                const firstChar = piece.charAt(0);
                return {
                    type: firstChar === '+' ? 'added' : firstChar === '-' ? 'removed' : 'context',
                    text: piece.slice(1)
                };
            })
        };
    });
}
class JsonDiffElement {
    constructor(rawElement) {
        this.rawElement = rawElement;
        if (typeof this.rawElement !== 'object') {
            throw new TypeError("JsonDiffElement -- invalid input: " + JSON.stringify(this.rawElement));
        }
    }
    get isNestedDiff() {
        return !Array.isArray(this.rawElement);
    }
    get isArrayDiff() {
        return this.rawElement.hasOwnProperty("_t");
    }
    diffAsObject() {
        let data = this.rawElement;
        switch (this.rawElement.length) {
            case DiffType.Addition:
                return [{ type: 'added', is: data[0] }];
            case DiffType.Modification:
                return [{ type: 'removed', was: data[0] }, { type: 'added', is: data[1] }];
            case DiffType.Other:
                switch (this.rawElement[2]) {
                    case DiffType.ArrayMove:
                        return [{ type: 'moved', where: data[1] }];
                    case DiffType.TextDiff:
                        return [{ type: 'uniDiff', diff: parseTextDiff(data[0]) }];
                    default:
                        return [{ type: 'removed', was: data[0] }];
                }
            default:
                throw new TypeError("Couldn't convert JsonDiffElement to object: " + JSON.stringify(this.rawElement));
        }
    }
}
let ChangeLogService = class ChangeLogService {
    constructor(_http, _talk, _version) {
        this._http = _http;
        this._talk = _talk;
        this._version = _version;
        this.adUnitGroups = [];
        this.bidderURL = '/bidder/';
        this.changeLogURL = '/changeLog/';
    }
    pullChangeLogByID(id) {
        this._http.get(this.bidderURL + id + this.changeLogURL)
            .toPromise()
            .then(response => {
            if (!response) {
                this.currentChangeLog = [];
            }
            this.currentChangeLog = JSON.parse(response._body);
        })
            .catch(err => {
            this._talk.handle;
        });
    }
    getCurrentChangeLog() {
        return this.currentChangeLog;
    }
    get() {
        return this.bidders;
    }
    /**
     * Convert jsonDiffPatch format to a nested structure that is a little easier to convert to markup
     * See https://github.com/benjamine/jsondiffpatch/blob/master/docs/deltas.md
     */
    parseJsonDiff(diff) {
        let e = new JsonDiffElement(diff);
        if (e.isNestedDiff) {
            if (e.isArrayDiff) {
                return this._mergeArrayDiffs(diff); // merge diffs which share the same index
            }
            else {
                return this._parseNestedDiffs(diff);
            }
        }
        else {
            return e.diffAsObject();
        }
    }
    _parseNestedDiffs(diff) {
        return Object.keys(diff).map(key => {
            return {
                type: 'nested',
                property: key,
                diffs: this.parseJsonDiff(diff[key])
            };
        });
    }
    _mergeArrayDiffs(diff) {
        const diffsByKey = Object.keys(diff)
            .filter(i => i !== '_t')
            .reduce((obj, key) => {
            const arrayIndex = key.replace('_', '');
            if (obj.hasOwnProperty(arrayIndex)) {
                obj[arrayIndex] = obj[arrayIndex].concat(this.parseJsonDiff(diff[key]));
            }
            else {
                obj[arrayIndex] = this.parseJsonDiff(diff[key]);
            }
            return obj;
        }, {});
        return Object.keys(diffsByKey)
            .map(key => {
            return {
                type: 'nested',
                property: Number(key),
                diffs: diffsByKey[key]
            };
        })
            .sort((a, b) => a.property - b.property)
            .map(i => {
            i.property = '#' + (i.property + 1); // 1-indexed instead of 0 for humans
            return i;
        });
    }
};
exports.ChangeLogService = ChangeLogService;
exports.ChangeLogService = ChangeLogService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        notification_service_1.NotificationService,
        version_pipe_1.VersionPipe])
], ChangeLogService);
//# sourceMappingURL=changelog.service.js.map